import { render, staticRenderFns } from "./AuthorizationPopup.vue?vue&type=template&id=43d1b41e&"
import script from "./AuthorizationPopup.vue?vue&type=script&lang=js&"
export * from "./AuthorizationPopup.vue?vue&type=script&lang=js&"
import style0 from "@/styles/AuthorizationPopup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports